export enum TaskType {
	Present = 'present',
	Reflect = 'reflect',
	Submit = 'submit',
	React = 'react',
	Review = 'review',
	Evaluate = 'evaluate'
}

export interface TaskInstruction {
	id: number;
	task_id: number;
	text: string;
	created_by?: number;
	created_at?: string;
	media?: any;
}

export interface Task {
	id: number;
	completed: boolean;
	name: string;
	requirements: Partial<Record<TaskRequirements, number>> |
		Partial<Record<TaskOperators, Partial<Record<TaskRequirements, number>>[]>>;
	sort_order: number;
	type: TaskType;
	instruction?: TaskInstruction | null;
	deleted_at?: string;
	deleted_by?: number;
}

export enum TaskOperators {
	And = 'and',
	Or = 'or',
	Not = 'not',
}

export enum TaskRequirements {
	PresentedSessions = 'presentedSessions',
	ReflectedComments = 'reflectedComments',
	SubmittedSessions = 'submittedSessions',
	ReactedComments = 'reactedComments',
	UnreviewedInstructorComments = 'unreviewedInstructorComments',
	UnreviewedInstructorRubrics = 'unreviewedInstructorRubrics',
	ReviewedInstructorComments = 'reviewedInstructorComments',
	ReviewedInstructorRubrics = 'reviewedInstructorRubrics',
	ReviewedPeerComments = 'reviewedPeerComments',
	ReviewedPeerRubrics = 'reviewedPeerRubrics',
	ReactedPeerComments = 'reactedPeerComments',
	ReviewedPeerInstructorOverrideComments = 'reviewedPeerInstructorOverrideComments',
	ReviewedPeerInstructorOverrideRubrics = 'reviewedPeerInstructorOverrideRubrics',
	ReviewedBulkFeedbackComments = 'reviewedBulkFeedbackComments',
	ReviewedBulkFeedbackRubrics = 'reviewedBulkFeedbackRubrics'
}
